import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  connect () {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: '.handle',
      onEnd: this.reorder.bind(this),
    });
  }

  reorder (event) {
    const position = event.newIndex + 1;
    const formElement = event.item.querySelector('form');
    const submit = formElement.querySelector('.js-row__submit');

    formElement.querySelector('#js-position-value').value = position;
    submit.click();
  }
}
